<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/transaction/detail/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="filter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <el-select v-model="filter.dlr_status" size="small" class="max-width-120">
                            <el-option v-for="(val, idx) in dlr_status_str" :key="idx" :value="idx*1"
                                       :label="val"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="filter.tz" size="small" class="max-width-120">
                            <el-option v-for="(val,idx) in options.tzs" :key="idx" :label="val.label"
                                       :value="val.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" style="padding-top: 1px;">
                        <el-date-picker
                            class="max-width-160"
                            size="small"
                            format="MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="dateRange"
                            type="daterange"
                            range-separator="~"
                            start-placeholder="From"
                            end-placeholder="To">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="filter.message_id" :placeholder="$strings('word/message_id')" size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="filter.src_address" :placeholder="$strings('word/src_address')" size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="filter.dest_address" :placeholder="$strings('word/dest_address')"
                                  size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <FilterCp v-model="filter.cp_id" @load="onLoadCp" class="max-width-120"/>
                    </el-form-item>
                    <el-form-item label="">
                        <FilterSp v-model="filter.sp_id" @load="onLoadCp" class="max-width-120"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/search')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                        <el-button @click="onExport" size="small" icon="el-icon-download">
                            {{$strings('word/export')}}
                        </el-button>
                        <el-button @click="onExportMessage" size="small" icon="el-icon-download">
                            {{$strings('word/message')}}
                        </el-button>

                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div>
            <el-table v-loading="loadingTable" border :data="tableData" class="el-table-thin">
                <el-table-column prop="id" :label="$strings('word/id')" width="80"></el-table-column>

                <!--                <el-table-column prop="cp_data" :label="$strings('word/cp_data')" width="200" show-overflow-tooltip></el-table-column>-->
                <el-table-column prop="sp_id" :label="$strings('word/sp_id')" width="100"></el-table-column>
                <el-table-column prop="cp_id" :label="$strings('word/cp_id')" width="100"></el-table-column>
                <el-table-column prop="cp_app_id" :label="$strings('word/cp_app_id')" width="160"></el-table-column>
                <el-table-column prop="dest_address" :label="$strings('word/msisdn')" width="120"></el-table-column>
                <el-table-column prop="src_address" :label="$strings('word/sender')" width="120"></el-table-column>
                <el-table-column prop="country" :label="$strings('word/country')" width="100"></el-table-column>

                <el-table-column prop="send_status" :label="$strings('word/status_send')" width="100"></el-table-column>
                <!--                <el-table-column prop="campaign_id" :label="$strings('word/campaign_id')" width="120"></el-table-column>-->
                <!--                <el-table-column prop="tpl_id" :label="$strings('word/tpl_id')" width="100"></el-table-column>-->
                <el-table-column prop="schedule_time" :label="$strings('word/schedule_time')"
                                 width="100"></el-table-column>
                <el-table-column prop="dlr_status" :label="$strings('word/status_deliver')"
                                 width="120">
                    <template slot-scope="scope">
                        <span>{{ dlr_status_str[scope.row.dlr_status] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="dlr_err_code" :label="$strings('word/dlr_err_code')"
                                 width="160"></el-table-column>
                <el-table-column prop="dlr_err_msg" :label="$strings('word/dlr_err_msg')"
                                 width="160" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dlr_submit_time" :label="$strings('word/dlr_submit_time')"
                                 width="160">
                    <template slot-scope="scope">{{ unix2date(scope.row.dlr_submit_time) }}</template>
                </el-table-column>
                <el-table-column prop="dlr_done_time" :label="$strings('word/dlr_done_time')"
                                 width="160">
                    <template slot-scope="scope">{{ unix2date(scope.row.dlr_done_time) }}</template>
                </el-table-column>
                <el-table-column prop="dlr_is" :label="$strings('word/dlr_is')"
                                 width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')" width="160">
                    <template slot-scope="scope">{{ unix2date(scope.row.ct_time) }}</template>
                </el-table-column>

                <el-table-column prop="amount" :label="$strings('word/amount')" width="100"></el-table-column>
                <el-table-column prop="mid" :label="$strings('word/mid')" width="300"></el-table-column>
                <el-table-column prop="message_id" :label="$strings('word/message_id')" width="300"></el-table-column>
                <el-table-column prop="link_id" :label="$strings('word/link_id')" width="100"></el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/operation')" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showMessage(scope.row.mid)"
                                   :loading="loadingContent">
                            {{ $strings('word/show_message') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination table-pagination" v-if="!loadingTable && pagination.total > pagination.size">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page"
                               @current-change="refreshTable"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    SpSiteMessageExport,
    SpSiteMessageRead,
    SpSiteTransactionDetailExport,
    SpSiteTransactionDetailRead
} from "@/api/spsite/api";
import {DefaultDate, UnixToDateFull} from "@/utils/time";
import {GetItem} from "@/utils/storage";
import {DLR_STATUS, DLR_SUCCESS, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import FilterCp from '@/components/filter/cp'
import FilterSp from '@/components/filter/sp'
import {Timezones} from "@/utils/timezone";

let defaultTz = GetItem(STORAGE_KEY_LOGIN_TZ, 0) * 1;

export default {
    name: "spsite-transaction-detail",
    components: {FilterCp, FilterSp},
    data() {
        return {
            loadingTable: true,
            tableData: [],
            pagination: {total: 0, page: 1, size: 20},
            filter: {
                tz: defaultTz ? defaultTz : 0,
                dest_address: '',
                src_address: '',
                cp_id: '',
                date_start: '',
                date_end: '',
                dlr_status: 100,
            },
            loadingContent: false,
            mapping: {cps: {}},
            dlr_status_str: DLR_STATUS,
            dlr_status_success: DLR_SUCCESS,
            options: {tzs: Timezones,},
            dateRange: [DefaultDate(), DefaultDate()],
        }
    },
    created() {
        this.refreshTable();
    },
    methods: {
        showMessage(mid) {
            this.loadingContent = true;
            SpSiteMessageRead({mid: mid, page: 1, size: 10}).then((resp) => {
                let content = "";
                if (resp.data.data.count > 0) {
                    content = resp.data.data.rows[0].content
                } else {
                    content = "Missing content"
                }
                this.$alert(content, this.$strings('word/message_content'), {
                    confirmButtonText: 'OK'
                })
            }).catch(() => {

                this.$alert("EMPTY", this.$strings('word/message_content'), {
                    confirmButtonText: 'OK',
                    type: 'error'
                })


            }).finally(() => {
                this.loadingContent = false;
            })
        },
        onLoadCp(cps) {
            this.mapping.cps = {};
            cps.forEach((item) => {
                this.mapping.cps[item.cp_id] = item.cp_name;
            });
        },
        onLoadSp(sps) {
            this.mapping.sps = {};
            sps.forEach((item) => {
                this.mapping.sps[item.sp_id] = item.sp_name;
            });
        },
        unix2date(ts) {
            return UnixToDateFull(ts, GetItem(STORAGE_KEY_LOGIN_TZ) * 1);
        },
        onFilter() {
            this.refreshTable();
        },
        onReset() {
            this.filter = {};
            this.filter.dlr_status = 100;
            this.refreshTable();
        },
        onExportMessage() {
            this.loadingTable = true;
            this.populateFilter();
            SpSiteMessageExport(this.filter).then((resp) => {
                this.loadingTable = false;
                window.location.href = resp.data.data.link;
            }).finally(() => {
                this.loadingTable = false;
            })
        },
        onExport() {
            this.loadingTable = true;
            this.populateFilter();
            SpSiteTransactionDetailExport(this.filter).then((resp) => {
                this.loadingTable = false;
                window.location.href = resp.data.data.link;
            }).finally(() => {
                this.loadingTable = false;
            })
        },
        populateFilter() {
            if (this.dateRange.length > 0) {
                this.filter.date_start = this.dateRange[0];
                this.filter.date_end = this.dateRange[1];
            } else {
                this.filter.date_start = '';
                this.filter.date_end = '';
            }
            this.filter.dlr_status = this.filter.dlr_status * 1;
            this.filter.page = this.pagination.page;
            this.filter.size = this.pagination.size;
        },
        refreshTable() {
            this.loadingTable = true;
            this.populateFilter();
            SpSiteTransactionDetailRead(this.filter).then((resp) => {
                this.pagination.total = resp.data.data.count;
                this.tableData = resp.data.data.count > 0 ? resp.data.data.rows : [];
            }).finally(() => {
                this.loadingTable = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>